module.exports = __webpack_public_path__ + "media/images/mobile/title_pink_q-b7417ac90527b99741c86506880219ab.gif";